// // UnderDevelopment.jsx
// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import {
//   FaCode,
//   FaCog,
//   FaRocket,
//   FaPaintBrush,
//   FaShieldAlt,
//   FaArrowLeft,
//   FaHome
// } from 'react-icons/fa';

// const UnderDevelopment = () => {
//   const navigate = useNavigate();

//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         delayChildren: 0.3,
//         staggerChildren: 0.2
//       }
//     }
//   };

//   const itemVariants = {
//     hidden: { y: 20, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1
//     }
//   };

//   return (
//     <div className="min-h-screen -my-6 -mx-4 bg-gradient-to-br from-purple-700 via-indigo-800 to-blue-900 overflow-hidden relative">
//       {/* Animated Background Shapes */}
//       <div className="absolute inset-0 overflow-hidden">
//         <motion.div
//           animate={{
//             scale: [1, 1.2, 1],
//             rotate: [0, 180, 360],
//           }}
//           transition={{
//             duration: 20,
//             repeat: Infinity,
//             ease: "linear"
//           }}
//           className="absolute -top-20 -left-20 w-40 h-40 bg-purple-500 rounded-full opacity-20 blur-xl"
//         />
//         <motion.div
//           animate={{
//             scale: [1, 1.5, 1],
//             rotate: [360, 180, 0],
//           }}
//           transition={{
//             duration: 25,
//             repeat: Infinity,
//             ease: "linear"
//           }}
//           className="absolute top-1/2 -right-20 w-60 h-60 bg-blue-500 rounded-full opacity-20 blur-xl"
//         />
//         <motion.div
//           animate={{
//             scale: [1, 1.3, 1],
//             rotate: [0, -180, -360],
//           }}
//           transition={{
//             duration: 30,
//             repeat: Infinity,
//             ease: "linear"
//           }}
//           className="absolute -bottom-20 left-1/3 w-52 h-52 bg-indigo-500 rounded-full opacity-20 blur-xl"
//         />
//       </div>

//       {/* Main Content */}
//       <div className="relative z-10 flex items-center justify-center min-h-screen p-4">
//         <motion.div
//           variants={containerVariants}
//           initial="hidden"
//           animate="visible"
//           className="max-w-4xl w-full"
//         >
//           {/* Glass Card Container */}
//           <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 shadow-2xl border border-white/20">

//             {/* Animated Gears */}
//             <motion.div className="flex justify-center mb-8">
//               <div className="relative w-32 h-32">
//                 <motion.div
//                   animate={{ rotate: 360 }}
//                   transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
//                   className="absolute inset-0"
//                 >
//                   <FaCog className="w-20 h-20 text-purple-400 absolute top-0 left-1/2 transform -translate-x-1/2" />
//                 </motion.div>
//                 <motion.div
//                   animate={{ rotate: -360 }}
//                   transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
//                   className="absolute inset-0"
//                 >
//                   <FaCog className="w-16 h-16 text-blue-400 absolute bottom-0 right-0" />
//                 </motion.div>
//                 <motion.div
//                   animate={{ rotate: 360 }}
//                   transition={{ duration: 2.5, repeat: Infinity, ease: "linear" }}
//                   className="absolute inset-0"
//                 >
//                   <FaCog className="w-12 h-12 text-indigo-400 absolute bottom-0 left-0" />
//                 </motion.div>
//               </div>
//             </motion.div>

//             {/* Title */}
//             <motion.h1
//               variants={itemVariants}
//               className="text-4xl md:text-6xl font-bold text-center mb-4"
//             >
//               <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-400 via-pink-400 to-indigo-400">
//                 Under Development
//               </span>
//             </motion.h1>

//             {/* Description */}
//             <motion.p
//               variants={itemVariants}
//               className="text-center text-gray-200 text-lg md:text-xl mb-8 max-w-2xl mx-auto"
//             >
//               We're crafting something extraordinary. This page will be ready soon!
//             </motion.p>

//             {/* Feature Cards */}
//             <motion.div
//               variants={itemVariants}
//               className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10"
//             >
//               <motion.div
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center hover:bg-white/20 transition-colors cursor-pointer"
//               >
//                 <FaRocket className="w-12 h-12 text-purple-400 mx-auto mb-4" />
//                 <h3 className="text-xl font-semibold text-white mb-2">Lightning Fast</h3>
//                 <p className="text-gray-300 text-sm">Optimized for speed and performance</p>
//               </motion.div>

//               <motion.div
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center hover:bg-white/20 transition-colors cursor-pointer"
//               >
//                 <FaPaintBrush className="w-12 h-12 text-pink-400 mx-auto mb-4" />
//                 <h3 className="text-xl font-semibold text-white mb-2">Modern Design</h3>
//                 <p className="text-gray-300 text-sm">Beautiful and intuitive interface</p>
//               </motion.div>

//               <motion.div
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center hover:bg-white/20 transition-colors cursor-pointer"
//               >
//                 <FaShieldAlt className="w-12 h-12 text-indigo-400 mx-auto mb-4" />
//                 <h3 className="text-xl font-semibold text-white mb-2">Secure</h3>
//                 <p className="text-gray-300 text-sm">Built with security in mind</p>
//               </motion.div>
//             </motion.div>

//             {/* CTA Buttons */}
//             <motion.div
//               variants={itemVariants}
//               className="flex flex-col sm:flex-row gap-4 justify-center"
//             >
//               <motion.button
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 onClick={() => window.history.back()}
//                 className="flex items-center justify-center gap-2 px-8 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold rounded-full hover:from-purple-700 hover:to-indigo-700 transition-all shadow-lg"
//               >
//                 <FaArrowLeft />
//                 Go Back
//               </motion.button>

//               <motion.button
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 onClick={() => navigate('/admin-dashboard')}
//                 className="flex items-center justify-center gap-2 px-8 py-3 bg-white/20 backdrop-blur-sm text-white font-semibold rounded-full hover:bg-white/30 transition-all border border-white/30"
//               >
//                 <FaHome />
//                 Home Page
//               </motion.button>
//             </motion.div>

//             {/* Code Animation */}
//             <motion.div
//               variants={itemVariants}
//               className="mt-10 flex justify-center"
//             >
//               <motion.div
//                 animate={{
//                   opacity: [0.5, 1, 0.5],
//                 }}
//                 transition={{
//                   duration: 2,
//                   repeat: Infinity,
//                   ease: "easeInOut"
//                 }}
//                 className="flex items-center gap-2 text-gray-400"
//               >
//                 <FaCode className="w-5 h-5" />
//                 <span className="font-mono text-sm">Building amazing things...</span>
//               </motion.div>
//             </motion.div>
//           </div>
//         </motion.div>
//       </div>

//       {/* Floating Particles */}
//       <div className="absolute inset-0 pointer-events-none">
//         {[...Array(15)].map((_, i) => (
//           <motion.div
//             key={i}
//             initial={{
//               x: Math.random() * window.innerWidth,
//               y: window.innerHeight + 100
//             }}
//             animate={{
//               y: -100,
//               x: Math.random() * window.innerWidth
//             }}
//             transition={{
//               duration: Math.random() * 10 + 10,
//               repeat: Infinity,
//               ease: "linear",
//               delay: Math.random() * 5
//             }}
//             className="absolute w-1 h-1 bg-white/30 rounded-full"
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default UnderDevelopment;

import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaCog,
  FaRocket,
  FaPaintBrush,
  FaShieldAlt,
  FaArrowLeft,
  FaHome,
  FaCode,
} from "react-icons/fa";

const UnderDevelopment = () => {
  const navigate = useNavigate();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.18,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
      },
    },
  };

  const features = [
    {
      icon: <FaRocket />,
      title: "Lightning Fast",
      desc: "Optimized for speed with a smooth and responsive experience.",
    },
    {
      icon: <FaPaintBrush />,
      title: "Modern Design",
      desc: "Beautiful interface crafted with premium user experience.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Highly Secure",
      desc: "Built using secure architecture and best development practices.",
    },
  ];
  const text1 = "Under";
  const text2 = "Development";
  return (
    <div className="relative overflow-hidden min-h-screen -mx-4 -my-6 bg-gradient-to-br from-[#3D0C10] via-[#7A151A] to-primary">
      {/* ================= Animated Background ================= */}

      <div className="absolute inset-0 overflow-hidden">
        {/* Glow 1 */}

        <motion.div
          animate={{
            scale: [1, 1.3, 1],
            x: [-50, 40, -50],
            y: [-30, 30, -30],
            rotate: [0, 360],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "linear",
          }}
          className="absolute -top-44 -left-40 h-[500px] w-[500px] rounded-full bg-primary/30 blur-[130px]"
        />

        {/* Glow 2 */}

        <motion.div
          animate={{
            scale: [1, 1.4, 1],
            x: [40, -60, 40],
            rotate: [360, 0],
          }}
          transition={{
            duration: 24,
            repeat: Infinity,
            ease: "linear",
          }}
          className="absolute bottom-0 right-0 h-[500px] w-[500px] rounded-full bg-red-700/20 blur-[150px]"
        />

        {/* Glow 3 */}

        <motion.div
          animate={{
            opacity: [0.2, 0.6, 0.2],
          }}
          transition={{
            duration: 5,
            repeat: Infinity,
          }}
          className="absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary/20 blur-[120px]"
        />

        {/* Grid */}

        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `
              linear-gradient(rgba(255,255,255,.08) 1px, transparent 1px),
              linear-gradient(90deg, rgba(255,255,255,.08) 1px, transparent 1px)
            `,
            backgroundSize: "50px 50px",
          }}
        />
      </div>

      {/* ================= Main ================= */}

      <div className="relative z-10 flex min-h-screen items-center justify-center px-5 py-12">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="w-full max-w-5xl"
        >
          {/* Glass Card */}

          <div className="rounded-[35px] border border-white/10 bg-white/5 p-8 shadow-[0_0_80px_rgba(223,31,38,.25)] backdrop-blur-2xl md:p-14">
            {/* ================= Gears ================= */}

            <motion.div
              variants={itemVariants}
              className="mb-10 flex justify-center"
            >
              <div className="relative flex h-40 w-40 items-center justify-center">
                {/* Pulse */}

                <motion.div
                  animate={{
                    scale: [1, 1.5, 1],
                    opacity: [0.5, 0, 0.5],
                  }}
                  transition={{
                    duration: 2.2,
                    repeat: Infinity,
                  }}
                  className="absolute h-40 w-40 rounded-full bg-primary/20 blur-3xl"
                />

                {/* Main Gear */}

                <motion.div
                  animate={{
                    rotate: 360,
                  }}
                  transition={{
                    duration: 8,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                >
                  <FaCog className="text-[85px] text-primary" />
                </motion.div>

                {/* Gear 2 */}

                <motion.div
                  animate={{
                    rotate: -360,
                  }}
                  transition={{
                    duration: 5,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                  className="absolute -right-4 top-1"
                >
                  <FaCog className="text-[48px] text-red-300" />
                </motion.div>

                {/* Gear 3 */}

                <motion.div
                  animate={{
                    rotate: 360,
                  }}
                  transition={{
                    duration: 4,
                    repeat: Infinity,
                    ease: "linear",
                  }}
                  className="absolute bottom-1 left-0"
                >
                  <FaCog className="text-[40px] text-red-200" />
                </motion.div>
              </div>
            </motion.div>

            {/* ================= Heading ================= */}

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="text-center pb-2"
            >
              <h1 className="text-5xl md:text-7xl font-bold overflow-hidden ">
                <div className="flex justify-center gap-[2px] overflow-hidden">
                  {text1.split("").map((letter, index) => (
                    <motion.span
                      key={index}
                      initial={{
                        y: 120,
                        opacity: 0,
                        rotateX: 90,
                      }}
                      animate={{
                        y: 0,
                        opacity: 1,
                        rotateX: 0,
                      }}
                      transition={{
                        delay: index * 0.08,
                        duration: 0.6,
                        type: "spring",
                        stiffness: 120,
                      }}
                      className="inline-block bg-gradient-to-r from-white via-red-200 to-primary bg-clip-text text-transparent"
                    >
                      {letter}
                    </motion.span>
                  ))}
                </div>

                <div className="mt-2 flex justify-center gap-[2px] overflow-hidden">
                  {text2.split("").map((letter, index) => (
                    <motion.span
                      key={index}
                      initial={{
                        y: 120,
                        opacity: 0,
                        rotateX: 90,
                      }}
                      animate={{
                        y: 0,
                        opacity: 1,
                        rotateX: 0,
                      }}
                      transition={{
                        delay: 0.6 + index * 0.05,
                        duration: 0.6,
                        type: "spring",
                        stiffness: 120,
                      }}
                      whileHover={{
                        scale: 1.2,
                        color: "#fff",
                      }}
                      className="inline-block bg-gradient-to-r from-primary via-red-400 to-white bg-clip-text text-transparent"
                    >
                      {letter}
                    </motion.span>
                  ))}
                </div>
              </h1>
            </motion.div>

            {/* ================= Description ================= */}

            <motion.p
              variants={itemVariants}
              className="mx-auto mt-8 max-w-3xl text-center text-lg leading-8 text-gray-300 md:text-xl"
            >
              We're working hard behind the scenes to build something
              exceptional. Stay tuned — an amazing experience is coming soon.
            </motion.p>

            {/* ================= Feature Cards ================= */}

            <motion.div
              variants={itemVariants}
              className="mt-14 grid gap-6 md:grid-cols-3"
            >
              {features.map((item, index) => (
                <motion.div
                  key={index}
                  whileHover={{
                    y: -10,
                    scale: 1.04,
                  }}
                  whileTap={{
                    scale: 0.97,
                  }}
                  className="group rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur-xl transition-all duration-300 hover:border-primary hover:bg-primary/10 hover:shadow-[0_0_35px_rgba(223,31,38,.35)]"
                >
                  <div className="mb-6 flex justify-center text-5xl text-primary transition duration-300 group-hover:scale-125 group-hover:rotate-6">
                    {item.icon}
                  </div>

                  <h3 className="mb-3 text-center text-2xl font-bold text-white">
                    {item.title}
                  </h3>

                  <p className="text-center leading-7 text-gray-400">
                    {item.desc}
                  </p>
                </motion.div>
              ))}
            </motion.div>
            {/* ================= CTA Buttons ================= */}

            <motion.div
              variants={itemVariants}
              className="mt-14 flex flex-col items-center justify-center gap-5 sm:flex-row"
            >
              <motion.button
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0px 0px 30px rgba(223,31,38,.55)",
                }}
                whileTap={{
                  scale: 0.95,
                }}
                onClick={() => window.history.back()}
                className="flex items-center gap-3 rounded-full bg-primary px-8 py-4 font-semibold text-white transition-all duration-300 hover:bg-[#c71b21]"
              >
                <FaArrowLeft />
                Go Back
              </motion.button>

              <motion.button
                whileHover={{
                  scale: 1.05,
                }}
                whileTap={{
                  scale: 0.95,
                }}
                onClick={() => navigate("/admin-dashboard")}
                className="flex items-center gap-3 rounded-full border border-white/15 bg-white/5 px-8 py-4 font-semibold text-white backdrop-blur-xl transition-all duration-300 hover:bg-white/10"
              >
                <FaHome />
                Dashboard
              </motion.button>
            </motion.div>

            {/* ================= Bottom Code ================= */}

            <motion.div
              variants={itemVariants}
              className="mt-12 flex justify-center"
            >
              <motion.div
                animate={{
                  opacity: [0.5, 1, 0.5],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                }}
                className="flex items-center gap-3 rounded-full border border-primary/20 bg-primary/10 px-6 py-3 text-[#ff9da0]"
              >
                <FaCode />
                <span className="font-mono">Building Amazing Things...</span>
              </motion.div>
            </motion.div>
          </div>
        </motion.div>
      </div>

      {/* ================= Floating Particles ================= */}

      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        {[...Array(30)].map((_, index) => (
          <motion.span
            key={index}
            className="absolute rounded-full bg-primary"
            style={{
              width: Math.random() * 5 + 2,
              height: Math.random() * 5 + 2,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              boxShadow: "0 0 18px rgba(223,31,38,.9)",
            }}
            animate={{
              y: [-30, -180],
              opacity: [0, 1, 0],
              scale: [0.5, 1.5, 0.5],
              x: [0, Math.random() * 50 - 25, Math.random() * 80 - 40],
            }}
            transition={{
              duration: Math.random() * 8 + 8,
              repeat: Infinity,
              delay: Math.random() * 6,
              ease: "linear",
            }}
          />
        ))}
      </div>

      {/* ================= Animated Border Glow ================= */}

      <motion.div
        animate={{
          opacity: [0.15, 0.4, 0.15],
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
        }}
        className="pointer-events-none absolute inset-0 border-[3px] border-primary/20"
      />
    </div>
  );
};

export default UnderDevelopment;
